import type { RouteRecordRaw } from "vue-router";
import { anonRoute, parentRoute, route } from "./utilities";
//import store from "@/state/store";

//start old routes
const folioRoutes = [
   route("folio-marketplace", "marketplace", "folio/marketplace-page", { title: "Marketplace Listings" }),
   route("folio-ignored", "ignored", "folio/ignored-page", { title: "Ignored" }),
   route("folio-featured", "featured", "folio/featured-page", { title: "Featured" }),
   route("search-my-searches", "saved-searches", "folio/saved-searches-page", { title: "My Searches" }),
   route("folio-favorites", "favorites", "folio/favorites-page", { title: "Favorites" }, undefined, route => ({ ...route.params, Favorites: true })),

   route("folio-my-investments-portfolios", "my-portfolios", "portfolio-insights/portfolios-page", { title: "My Portfolios" }, undefined, route => ({ ...route.params, currentUser: true })),
   route("folio-my-investments-portfolio", "my-portfolios/:portfolioId/portfolio", "portfolio-insights/portfolio-page", { title: "My Portfolio" }, undefined, route => ({ ...route.params, currentUser: true })),
   route("folio-my-investments-property", "my-portfolios/:portfolioId/property/:propId", "property/view-page", { title: "Portfolio Insights" }, undefined, route => ({ ...route.params, portfolioId: Number.parseInt(route.params.portfolioId as string, 10), propId: Number.parseInt(route.params.propId as string, 16) })),
];
const searchRoutes = [
   route("search-mls-zip", "mls/:zip", "search/mls-page", { title: "Search MLS" }),
   route("search-mls", "mls", "search/mls-page", { title: "Search MLS" }),
   route("search-saved", "saved/:id/:name", "search/mls-page", { title: "Search MLS" }),

   route("portfolio-finder", "/portfolio-finder-2", "portfolio-finder/portfolio-finder-page", { title: "Portfolio Finder" }),
];
//end old routes

const marketplaceRoutes = [
   route("marketplace-search", "search", "marketplace/search-page", { title: "Marketplace Listings" }),
   route("marketplace-my", "my", "marketplace/my-listings-page", { title: "My Marketplace Listings" }),
   route("marketplace-add", ":id/add", "marketplace/edit-page", { title: "Add Marketplace Listing" }),
   route("marketplace-edit", ":mlsNumber/edit", "marketplace/edit-page", { title: "Edit Marketplace Listing" }, undefined, route => ({ mlsNumber: route.params.mlsNumber, edit: true })),
   route("marketplace-review", ":mlsNumber/review", "marketplace/review-page", { title: "Review Marketplace Listing" }, undefined, route => ({ mlsNumber: route.params.mlsNumber })),
];
const propertySuiteRoutes = [
   route("folio-existing-investments", "existing-investments", "folio/favorites-page", { title: "Favorites" }, undefined, route => ({ ...route.params, ExistingInvestments: true })),
   
   route("search-pre-foreclosures", "pre-foreclosures", "search/pre-foreclosures-page", { title: "Search Pre-Foreclosures" }),
];
const portfolioFinderRoutes = [
   parentRoute("portfolio-finder-search-root", "search", [
      route("portfolio-finder-search", "", "portfolio-finder/search-page", { title: "Search - Portfolio Finder" }),
      //route("portfolio-finder-owner", "/portfolio-finder/:id", "portfolio-finder/owner-page", { title: "Portfolio Finder" }),
   ]),
   route("portfolio-finder-fiduciaries", "fiduciaries", "portfolio-finder/fiduciaries-page", { title: "Fiduciaries - Portfolio Finder" }),
   route("portfolio-finder-favorite", "favorites", "portfolio-finder/favorite-page", { title: "Favorites - Portfolio Finder" }),
   route("portfolio-finder-ignored", "ignored", "portfolio-finder/ignore-page", { title: "Ignored - Portfolio Finder" }),
   route("portfolio-finder-pm-investors", "investor-agents", "portfolio-finder/investor-agents-page", { title: "Investors Agents - Portfolio Finder" }),
   route("portfolio-finder-pm-agents", "pm-agents", "portfolio-finder/pm-agents-page", { title: "PM Agents - Portfolio Finder" }),
   route("portfolio-finder-custom-targets", "custom-targets", "portfolio-finder/custom-targets-page", { title: "Custom Targets - Portfolio Finder" }),
   route("rental-scout", "rental-scout", "rental-scout/index-page", { title: "Rental Scout" }),   
];
const gatewayIdxRoutes = [
   route("investment-gateway-clients", "clients", "clients/investment-gateway-clients-page", { title: "Investment Gateway Clients" }),
];
const folioRoutesMyPortfolios = [
];
const portfolioInsightsRoutes = [
   route("portfolio-insights-clients", "clients", "clients/portfolio-insights-clients-page", { title: "Portfolio Insights Clients" }),

   route("PI-portfolios", "clients/:clientId/portfolios", "portfolio-insights/portfolios-page", { title: "Portfolio Insights" }, undefined, route => ({ ...route.params, clientId: Number.parseInt(route.params.clientId as string, 10) })),
   route("PI-client-portfolio", "clients/:clientId/portfolios/:portfolioId/portfolio", "portfolio-insights/portfolio-page", { title: "Portfolio Insights" }, undefined, route => ({ ...route.params, clientId: Number.parseInt(route.params.clientId as string, 10), portfolioId: Number.parseInt(route.params.portfolioId as string, 10) })),
   route("PI-client-property", "clients/:clientId/portfolios/:portfolioId/property/:propId", "property/view-page", { title: "Portfolio Insights" }, undefined, route => ({ ...route.params, clientId: Number.parseInt(route.params.clientId as string, 10), portfolioId: Number.parseInt(route.params.portfolioId as string, 10), propId: Number.parseInt(route.params.propId as string, 16) })),
   parentRoute("folio-my-investments", "my-portfolios", folioRoutesMyPortfolios),
];
const analysisRequestsRoutes = [
   route("rental-analysis-requests", "", "rental-analysis/requests-page", { title: "Analysis Requests" }),
   //   route("analysis-view", "/analysis/:token/", "property/view-page", { title: "Analysis Request" }),
   route("analysis-view", "/analysis/:state/:city/:zip/:address/:analysisToken", "property/view-page"),
];
const propertyPerformanceEngine = [
   parentRoute("property-performance-engine-requests", "requests", analysisRequestsRoutes),
];

export default [
   parentRoute("search", "/search", searchRoutes),
   parentRoute("folio", "/folio", folioRoutes),
   //routes above are obsolete old layout

   route("default", "/dashboard", "dashboard-page", { title: "Dashboard" }),
   parentRoute("marketplace", "/marketplace", marketplaceRoutes),
   parentRoute("property-suite", "/property-suite", propertySuiteRoutes),
   parentRoute("portfolio-finder", "/portfolio-finder", portfolioFinderRoutes),
   parentRoute("gateway-idx", "/investment-gateway", gatewayIdxRoutes),
   parentRoute("portfolio-insights", "/portfolio-insights", portfolioInsightsRoutes),
   parentRoute("property-performance-engine", "/property-performance-engine", propertyPerformanceEngine),





   //route("folio-client-investments", "/portfolio-insights/:id/client", "folio/my-investments-page", { title: "Client Investments" }),

   route("all-clients", "/clients", "clients/all-clients-page", { title: "My Clients" }),

   

   //route("portfolio-insights", "/portfolio-insights", "portfolio-insights/portfolio-page", { title: "Portfolio Insights" }),


   //route("account-profile", "/account/profile", "account/profile-page", { title: "My Account" }),
   //route("enterprise-settings", "/account/enterprise-settings", "account/enterprise-settings-page", { title: "Enterprise Settings" }),
   //route("account-investment-defaults", "/account/investment-defaults", "account/investment-defaults-page", { title: "Investment Defaults" }),
   route("account-settings", "/account/settings", "account/settings-page", { title: "Settings" }),
   route("brand-portal", "/account/brand", "account/brand-portal-page", { title: "Brand Portal" }),

   route("homes", "/homes/:state/:city/:zip/:address", "property/view-page", { title: "Residence" }),
   route("homes-id", "/homes/:propId", "property/view-page", { title: "Residence" }),
   route("homes-shared", "/share/:shareId", "property/view-page", { title: "Residence" }),
   route("homes-address-id", "/homes/:state/:city/:zip/:address/:propId", "property/view-page", { title: "Residence" }),
   anonRoute("homes-address-idx", "/homes/:state/:city/:zip/:address/idx/:shareToken", "property/view-page", { title: "IDX Share" }, undefined, route => { console.log('params', route.params); return ({ ...route.params, isIdx: true }); }),
   anonRoute("homes-lookup-share", "/homes/:state/:city/:zip/:address/share/:shareToken", "property/view-page", { title: "Property Share" }, undefined, route => { console.log('params', route.params); return ({ ...route.params, isIdx: true }); }),
   
   anonRoute("shared-view", "/share/:shareToken", "property/view-page", { title: "Property Share" }),
   anonRoute("shared-mls-view", "/mls/:mlsSource/:mlsNumber/share/:shareToken", "property/view-page", { title: "Property Share" }),
   anonRoute("analysis-request-view", "/analysis/:shareToken", "property/view-page", { title: "Performance Engine Share" }),
   
   route("mls-listing", "/mls/:mlsSource/:mlsNumber", "property/view-page", { title: "MLS Listing" }),
   route("mls-number-address", "/mls/:mlsSource/:mlsNumber/:state/:city/:zip/:address", "property/view-page", { title: "MLS Listing" }),
   

   anonRoute("not-found", "/:pathMatch(.*)*", "errors/not-found", { title: "Not Found" }),

   anonRoute("error", "/error", "errors/error-page", { title: "Error" }),
   anonRoute("login", "/login", "login-page", { title: "Login" }),
   anonRoute("signup", "/signup", "signup/GroupPage", { title: "Signup" }),
   anonRoute("leads-owner", "/leads/:id", "login-page", { title: "Login" }, undefined, route => ({ ...route.params, pf: true })),
   anonRoute("portfolio-finder-owner", "/portfolio-finder/:id", "login-page", { title: "Login" }, undefined, route => ({ ...route.params, pf: true })),

   /*
   /account/brand
   /account/investment-defaults
   */
] as Array<RouteRecordRaw>;
